import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../utils/services/api.service';

@Component({
  selector: 'app-image-changes',
  templateUrl: './image-changes.component.html',
  styleUrls: ['./image-changes.component.scss']
})
export class ImageChangesComponent implements OnInit {
  images = []
  hotelIds = [];



  hotels;
  constructor(private apiService: ApiService) { }

  ngOnInit() {
    this.getImages()
  }
  getImages() {
    this.apiService.getImagesChanges().subscribe(res => {
      this.images = res.data
      this.hotels = {};
      this.images.forEach(item => {
        if(item) {
          if (item.subjectType == 'Hotel') {
            if (!this.hotels[item.subjectId]) {
              this.hotels[item.subjectId] = {
                hotelName: item.hotel.name,
                hotelImages: [{
                  id: item.id,
                  subjectId: item.subjectId,
                  imageUrl: item.imageUrl,
                  subjectType: item.subjectType,
                  providerOrganizationId: item.providerOrganizationId
                }]
              }
            } else {
              this.hotels[item.subjectId].hotelImages.push({
                id: item.id,
                subjectId: item.subjectId,
                imageUrl: item.imageUrl,
                subjectType: item.subjectType,
                providerOrganizationId: item.providerOrganizationId
              })
            }
          } else {
            if (this.hotels[item.hotel_room.hotelId]) {
              this.hotels[item.hotel_room.hotelId].hotelImages.push({
                id: item.id,
                subjectId: item.subjectId,
                imageUrl: item.imageUrl,
                subjectType: item.subjectType,
                roomInfo: item.hotel_room,
                providerOrganizationId: item.providerOrganizationId
              })
            } else {
              this.hotels[item.hotel_room.hotelId] = {
                hotelName: item.hotel_room.Hotel.name,
                hotelImages: [{
                  id: item.id,
                  subjectId: item.subjectId,
                  imageUrl: item.imageUrl,
                  subjectType: item.subjectType,
                  roomInfo: item.hotel_room,
                  providerOrganizationId: item.providerOrganizationId
                }]
              }
            }
          }
        }
       
      })

      console.log(this.hotels)

    })
  }

  deleteImage(image, imageIndex, imageList) {
    let data = {
      providerOrganizationId: image.providerOrganizationId
    }
    this.apiService.deleteHotelImage(image.id, { body: { providerOrganizationId: image.providerOrganizationId } }).subscribe((res) => {
      imageList.splice(
        imageIndex,
        1
      );
    })
  }

  approveImages(images, hotelId) {
    images.forEach((imageItem) => {
      let data = {
        providerOrganizationId: imageItem.providerOrganizationId
      }
      this.apiService.updateHotelImages(imageItem.id, data).subscribe((res) => {
        delete this.hotels[hotelId];
        this.hotels = {...this.hotels};
      })
    })

  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/image-changes/image-changes.component.ts